import React from 'react';

import { Link } from '../../Link';
import * as S from './styles';
import styled from 'styled-components';

const Title = styled.p`
  font-size: 1.5rem;
  margin-bottom: 12px;
  text-transform: uppercase;
`;

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const ListItem = styled.li``;

const Address = styled.address`
  font-style: normal;
  line-height: 1.5;
`;

export const ContactMenu = () => (
  <S.Wrapper>
    <Title>Contato</Title>
    <List>
      <ListItem>
        Já sou cliente: <br className="aparecerMobile" aria-hidden="true" />
        <S.Link to="tel:40041330" aria-label="Ligar para 4004-1330">
          4004-1330
        </S.Link>
      </ListItem>
      <ListItem>
        <S.Link to="/ofertas" aria-label="Ir para a página de ofertas">
          Quero ser cliente
        </S.Link>
      </ListItem>
      <ListItem>
        <Address>
          Av. Rebouças, 2880, 2º andar <br />
          Pinheiros, CEP 05.402-500 – São Paulo/SP
        </Address>
      </ListItem>
    </List>
  </S.Wrapper>
);
